export default "{\n    \"startTyping\": \"Commencez à saisir pour rechercher des bons de travail\",\n    \"noResults\": \"Aucun bon de travail trouvé\"\n}\n"